import { ErrorHandler, Injectable } from '@angular/core';
import logdna from '@logdna/browser';
import { environment } from '../environments/environment';


@Injectable({ providedIn: 'root' })
export class LogDnaErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (!environment().development) {
      logdna.error(error);
    }
  }
}
